export default __webpack_public_path__ + "static/media/Senator Michael Webber.09690097.jpg";